import {
  Typography, Button, Box, Card, CardContent
} from '@mui/material';

const ProfileComponent = ({ selectedFace, onCancel }) => {
  if (!selectedFace) return null;

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          Profile for Face {selectedFace.id}
        </Typography>

        {/* --- 1. VISUALIZE THE POSTERIOR IMAGE --- */}
        {/* We check if the URL exists before trying to render it. */}
        {selectedFace.age_posterior_url && (
          <Box sx={{ my: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Age Posterior Distribution
            </Typography>
            <img
              src={selectedFace.age_posterior_url}
              alt={`Age posterior distribution for face ${selectedFace.id}`}
              style={{
                width: '100%',       // Make the image responsive to the card width
                height: 'auto',      // Maintain aspect ratio
                display: 'block',    // Removes extra space below the image
                borderRadius: '4px'  // Give it slightly rounded corners
              }}
            />
          </Box>
        )}

        {/* --- 2. DISPLAY THE RAW DATA (Optional but useful) --- */}
        <Typography variant="subtitle2" gutterBottom sx={{ mt: 1 }}>
          Raw Data
        </Typography>
        <Box 
          component="pre" 
          sx={{ 
            backgroundColor: 'background.default', 
            p: 1, 
            borderRadius: 1, 
            whiteSpace: 'pre-wrap', 
            wordBreak: 'break-all',
            maxHeight: '200px', // Prevent the box from becoming too tall
            overflowY: 'auto'   // Add a scrollbar if content overflows
          }}
        >
          {JSON.stringify(selectedFace, null, 2)}
        </Box>

        <Button onClick={onCancel} variant="outlined" size="small" sx={{ mt: 2 }}>
          Close
        </Button>
      </CardContent>
    </Card>
  );
};

export default ProfileComponent;

/*
import {
  Typography, Button, Box, Card, CardContent
} from '@mui/material';

const ProfileComponent = ({ selectedFace, onCancel }) => {
  if (!selectedFace) return null;
  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>Profile for Face {selectedFace.id}</Typography>
        <Box component="pre" sx={{ backgroundColor: 'background.default', p: 1, borderRadius: 1, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
          {JSON.stringify(selectedFace, null, 2)}
        </Box>
        <Button onClick={onCancel} variant="outlined" size="small" sx={{ mt: 1 }}>Close</Button>
      </CardContent>
    </Card>
  );
};
export default ProfileComponent;
*/